// extracted by mini-css-extract-plugin
export default {"destination":"DestinationForm_destination__4GxKd","center":"DestinationForm_center__+g811"};